import { render, staticRenderFns } from "./TagActions.vue?vue&type=template&id=56513dd2"
import script from "./TagActions.vue?vue&type=script&lang=js"
export * from "./TagActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports